// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.calculation-text-empty-zatr {\r\n  color: #a29123 !important;\n}\n.calculation-text-empty-account {\r\n  color: #3666b6 !important;\n}\n.calculation-text-not-equal {\r\n  color: #c52c2c !important;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
